var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{staticClass:"pessoa",attrs:{"no-menu":"","no-title":"","menu":_vm.menu,"menu-active":_vm.activeMenu,"pad":"","hfull":""}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }